(() => {
  const root = document.querySelector('#MainContent[data-template*="product"]');
  if (!root || document.documentElement.dataset.yuPdpV2 === '1') return;
  document.documentElement.dataset.yuPdpV2 = '1';

  const details = root.querySelector('.product-details > .group-block');
  const buy = root.querySelector('.buy-buttons-block') || root.querySelector('.product-form-buttons');
  const picker = root.querySelector('variant-picker.variant-picker');
  if (!details) return;

  if (!details.querySelector('.yu-pdp-v2-badges')) {
    const badges = document.createElement('div');
    badges.className = 'yu-pdp-v2-badges';
    badges.innerHTML = '<span class="yu-pdp-v2-badge">PREMIUM CASES</span><span class="yu-pdp-v2-badge">MOBILE FIRST</span><span class="yu-pdp-v2-badge">SECURE CHECKOUT</span>';
    details.prepend(badges);
  }

  if (!details.querySelector('.yu-pdp-v2-offer')) {
    const offer = document.createElement('div');
    offer.className = 'yu-pdp-v2-offer';
    offer.innerHTML = '<div class="yu-pdp-v2-offer__head"><strong>Why shop TheYounique?</strong><span>ONLINE EXCLUSIVE</span></div><div class="yu-pdp-v2-offer__body"><div class="yu-pdp-v2-offer__item"><b>Premium Protection</b><span>Everyday phone protection</span></div><div class="yu-pdp-v2-offer__item"><b>Easy Model Selection</b><span>Choose your exact variant</span></div><div class="yu-pdp-v2-offer__item"><b>Fast Shopping</b><span>Simple add-to-cart flow</span></div></div>';
    if (buy) buy.insertAdjacentElement('beforebegin', offer); else details.appendChild(offer);
  }

  if (!details.querySelector('.yu-pdp-v2-trust')) {
    const trust = document.createElement('div');
    trust.className = 'yu-pdp-v2-trust';
    trust.innerHTML = '<div>🔒 Secure Checkout</div><div>📱 Exact Model Choice</div><div>💬 WhatsApp Support</div>';
    if (buy) buy.insertAdjacentElement('afterend', trust); else details.appendChild(trust);
  }

  if (picker) picker.setAttribute('data-yu-pdp-v2', 'true');
})();
